// "O ÁS DE OUROS" -> "O Ás de Ouros" (los títulos del tarot vienen en mayúsculas).
const SMALL = new Set(["de", "da", "do", "das", "dos", "e", "a", "o", "as", "os"])

export const titleCase = str =>
  String(str || "")
    .toLowerCase()
    .split(" ")
    .map((w, i) => (i > 0 && SMALL.has(w) ? w : w.charAt(0).toUpperCase() + w.slice(1)))
    .join(" ")
